export const getGenders = (state) => state.genders
